module.exports = {
  title: 'Coverflow Carousel with React Native Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-07-23',
  slug: 'coverflow-carousel',
  tags: ['reanimated'],
};
